// @flow
import React, { Component } from 'react';
import PartnerCardList from 'components/common/PartnerCardList/PartnerCardList';
import type { State } from 'store';
import { PartneringActions } from 'store/actionCreators';
import type { PartnerItem } from 'store/modules/partnering';
import { connect } from 'react-redux';
import throttle from 'lodash/throttle';
import { getScrollBottom, preventStickBottom } from 'lib/common';

type OwnProps = {
  sort: string,
  category: string,
};

type Props = OwnProps & {
  partners: ?(PartnerItem[]),
  prefetched: ?(PartnerItem[]),
  prefetching: boolean,
  loading: boolean,
  width: number,
  hasEnded: boolean,
  shouldCancel: boolean,
};

class PartneringPartnerCards extends Component<Props> {
  prevCursor: ?string = null;

  prefetch = async () => {
    const { partners, prefetching, loading, category, sort } = this.props;
    if (!partners || partners.length === 0 || prefetching || loading) return;
    const lastId = partners[partners.length - 1].id;
    if (this.props.prefetched) {
      PartneringActions.revealPrefetched('recent');
      await Promise.resolve(); // next tick
    }
    if (lastId === this.prevCursor) return;
    this.prevCursor = lastId;
    try {
      await PartneringActions.prefetchRecentPartners(lastId, category, sort);
    } catch (e) {
      console.log(e);
    }
    preventStickBottom();
    this.onScroll();
  };

  onScroll = throttle(() => {
    const scrollBottom = getScrollBottom();
    if (scrollBottom > 1000) return;
    this.prefetch();
  }, 250);

  initialize = async () => {
    const { partners, shouldCancel, category, sort } = this.props;
    try {
      if (partners && partners.length > 0) {
        // do not fetch partner data when already exists
        return;
      }
      if (!shouldCancel) {
        await PartneringActions.getRecentPartners('', category, sort);
      }
      this.prefetch();
    } catch (e) {
      console.log(e);
    }
  };

  listenScroll = () => {
    window.addEventListener('scroll', this.onScroll);
  };

  unlistenScroll = () => {
    window.removeEventListener('scroll', this.onScroll);
  };

  listenSort = async () => {
    const { category, sort } = this.props;
    await PartneringActions.getRecentPartners('', category, sort);
    this.prefetch();
  };

  componentDidMount() {
    this.initialize();
    this.listenScroll();
  }

  componentWillUnmount() {
    this.unlistenScroll();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.sort !== this.props.sort) {
      this.listenSort();
    }
  }

  render() {
    return (
      <PartnerCardList
        partners={this.props.partners}
        loading={this.props.loading}
        prefetching={
          (this.props.prefetched && this.props.prefetched.length > 0) || this.props.prefetching
        }
        width={this.props.width}
        hasEnded={this.props.hasEnded}
      />
    );
  }
}

const mapStateToProps = ({ partnering, pender, base, common }: State) => ({
  partners: partnering.recent.partners,
  prefetched: partnering.recent.prefetched,
  prefetching: pender.pending['partnering/PREFETCH'],
  loading: pender.pending['partnering/GET_RECENT_POSTS'],
  width: base.windowWidth,
  hasEnded: partnering.recent.end,
  shouldCancel: common.ssr && !common.router.altered,
});

export default connect(mapStateToProps, () => ({}))(PartneringPartnerCards);



// WEBPACK FOOTER //
// ./src/containers/list/PartneringPartnerCards.js